export function createHistorySlides(year, slidesCount) {
  let slidesMarkup = ``;

  for (let i = 0; i < slidesCount; i++) {
    slidesMarkup += `
        <li class="splide__slide">
            <picture>
                <source srcset="/img/slider/history-${year}-${i}.webp 1x, /img/slider/history-${year}-${i}@2x.webp 2x" type="image/webp" />
                <source srcset="/img/slider/history-${year}-${i}.jpg 1x, /img/slider/history-${year}-${i}@2x.jpg 2x" type="image/jpg" />
                <img class="history__img" src="/img/slider/history-${year}-${i}.jpg" alt="Фотография ${i} года ${year}" />
            </picture>
        </li>
        `;
  }
  return slidesMarkup;
}
